// src/pages/ContactPage.js
import React from 'react';
import SeoHead from '../seo/SeoHead';
import ContactHero from '../main/ContactHero';
import ContactForm from '../main/ContactForm';

export default function ContactPage() {
  return (
    <>
      <SeoHead
        title="Contact Us – Marrakech Reserve"
        description="Have questions or feedback about our Moroccan olive oil? Get in touch with our Marrakech Reserve team today."
        url="https://marrakech-reserve.com/contact-us"
        keywords="Marrakech Reserve, Moroccan olive oil, buy Moroccan olive oil, buy olive oil,  olive oil, contact, support, inquiries"
        // you can also pass twitterImage or ogImage props if you add them to SeoHead
      />
      <ContactHero />
      <ContactForm />
    </>
  );
}
